// extracted by mini-css-extract-plugin
export default {"Subpage":"costs_Subpage__BWpns","CostSection":"costs_CostSection__OrvHb"};